export { ManagePageFooter } from './ManagePageFooter'
